class LocationsPopup extends ModalDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventHandlers();

    if (this.dataset.openInDesignMode === 'true') {
      return;
    }
  }

  addEventHandlers() {
    if (this.dataset.openInDesignMode === 'true') {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.show();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        this.hide();
      });
    }
  }

  hide() {
    super.hide();
  }
}

customElements.define('locations-popup', LocationsPopup);
